// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { SiAnthropic as RawSiAnthropic } from "react-icons/si";
export const SiAnthropic = /* @__PURE__ */ createIcon(RawSiAnthropic, "SiAnthropic", 0);
